module.exports = __webpack_public_path__ + "static/media/allie02.98bebde2.jpg";